import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';

export default function SignUp() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        username: '',
        password: '',
        confirmPassword: '',
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading(true);

        // Perform form validation
        const errors = {};
        if (!formData.firstName) {
            errors.firstName = 'First Name is required.';
        }
        if (!formData.email) {
            errors.email = 'Email is required.';
        }
        if (!formData.username) {
            errors.username = 'User Name is required.';
        }
        if (!formData.password) {
            errors.password = 'Password is required.';
        }
        if (formData.password !== formData.confirmPassword) {
            errors.confirmPassword = 'Passwords do not match.';
        }

        if (Object.keys(errors).length === 0) {
            //Ajax call
        } else {
            setErrors(errors);
            setLoading(false);
        }
    };

    return (
        <Container>
            <Row className="vh-80 d-flex justify-content-center align-items-center mb-4">
                <Col xs={12} md={8} lg={5}>
                    <div className="border border-3 border-primary"></div>
                    <Card className="shadow">
                        <Card.Body>
                            <div className="mb-3">
                                <h3 className="fw-bold text-center">Sign Up</h3>
                                <p className="mb-2 text-center">
                                    Already signed up? <a href="/login" className="text-primary fw-bold">
                                        Log In
                                    </a>{' '}
                                    OR {' '}
                                    <a href="/forgotpassword" className="text-primary fw-bold">
                                        Reset Password
                                    </a>
                                </p>
                                <div className="mb-3">
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3" controlId="formBasicFirstName">
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="firstName"
                                                placeholder="Enter First Name"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.firstName && <Form.Text className="text-danger">{errors.firstName}</Form.Text>}
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicLastName">
                                            <Form.Label>Last Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="lastName"
                                                placeholder="Enter Last Name"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicPhoneNumber">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="phoneNumber"
                                                placeholder="Enter Phone Number"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                onKeyPress={(e) => isNumberKey(e)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="Enter Email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.email && <Form.Text className="text-danger">{errors.email}</Form.Text>}
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicUsername">
                                            <Form.Label>User Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="username"
                                                placeholder="Enter User Name"
                                                value={formData.username}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.username && <Form.Text className="text-danger">{errors.username}</Form.Text>}
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="password"
                                                placeholder="Enter Password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.password && <Form.Text className="text-danger">{errors.password}</Form.Text>}
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
                                            <Form.Label>Confirm Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="confirmPassword"
                                                placeholder="Confirm Password"
                                                value={formData.confirmPassword}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.confirmPassword && <Form.Text className="text-danger">{errors.confirmPassword}</Form.Text>}
                                        </Form.Group>

                                        <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                                            {loading ? 'Loading...' : 'Register'}
                                        </Button>
                                    </Form>
                                    <p className="my-2 text-center">
                                    Already signed up? <a href="/login" className="text-primary fw-bold">
                                        Log In
                                    </a>{' '}
                                    OR {' '}
                                    <a href="/forgotpassword" className="text-primary fw-bold">
                                        Reset Password
                                    </a>
                                </p>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>

                </Col>
            </Row>
        </Container>
    );
}
